import React from "react";
import {
  Navbar,
  NavbarBrand,
  NavbarCollapse,
  NavbarToggle,
} from "flowbite-react";
import { NavbarSubmenu } from "@/components/parts/header/MenuItem";
import NekometryLogo from "@/assets/images/nekometry_logo_trimmed.png";
import { MENU_CATEGORIES } from "@/constants/Menu";

const Header: React.FC = () => {
  return (
    <Navbar
      data-sticky-header
      fluid
      rounded
      className="sticky top-0 z-50 bg-canvas md:py-1"
    >
      <NavbarBrand href="/">
        <img
          src={NekometryLogo}
          className="mr-3 h-12 w-12 sm:h-14 sm:w-14"
          width={56}
          height={56}
          alt="Nekometry"
        />
      </NavbarBrand>
      <NavbarToggle />
      <NavbarCollapse>
        {MENU_CATEGORIES.map((category) => (
          <NavbarSubmenu key={category.id} category={category} />
        ))}
      </NavbarCollapse>
    </Navbar>
  );
};
export default Header;
